export default "__VITE_ASSET__GtDO$Oe8__"